var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_84",
    x: 0,
    y: 0,
    width: 126,
    height: 126,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(-10434 3002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 10434, -3002)",
    filter: "url(#Ellipse_84)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84-2",
    "data-name": "Ellipse 84",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(30 24)",
    fill: "#fff",
    opacity: 0.19
  })), /*#__PURE__*/React.createElement("g", {
    id: "login_black_24dp",
    transform: "translate(10477.867 -2961.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_349",
    "data-name": "Rectangle 349",
    width: 33,
    height: 33,
    transform: "translate(0.132 0.133)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(2.805 4.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M14.62,8.609l-1.963,1.963L16.3,14.218H2v2.8H16.3l-3.646,3.646,1.963,1.963,7.011-7.011Zm12.62,16.827H16.023v2.8H27.241a2.813,2.813,0,0,0,2.8-2.8V5.8a2.813,2.813,0,0,0-2.8-2.8H16.023V5.8H27.241Z",
    transform: "translate(-2 -3)",
    fill: "#3172ba"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogIn);
export default __webpack_public_path__ + "static/media/logIn.9f670f55e72e58b18d811e81bc648202.svg";
export { ForwardRef as ReactComponent };